module.exports = __webpack_public_path__ + "static/paper-small-003f096030ff6b9284f4f2489781353a.webp";